export const buttonTheme = {
  css: (): string => `
  .p-button.p-button-sm,
  .p-button.p-button-sm .p-button-label {
    height: 36px !important;
    min-height: 36px !important;
    line-height: 1 !important;
    display: flex !important;
    align-items: center !important;
  }

  .p-button.p-button-sm button {
    height: 36px !important;
    min-height: 36px !important;
    display: flex !important;
    align-items: center !important;
  }
  `,
  root: {
    label: {
      fontWeight: '700'
    },
    paddingX: '10px',
    paddingY: '8px',
    sm: {
      paddingX: '16px',
      paddingY: '10px',
      fontSize: '14px'
    }
  },
  outlined: {
    primary: {
      borderColor: '{sd.primary.normal}'
    }
  },
  colorScheme: {
    light: {
      sd: {
        form: {
          background: {
            color: '{sd.form.action.background.color}',
            hover: '{sd.form.action.background.hover}'
          }
        }
      },
      root: {
        primary: {
          background: '{button.idle.background}',
          hoverBackground: '{button.hover.background}',
          activeBackground: '{button.active.background}',
          borderColor: '{button.idle.background}',
          hoverBorderColor: '{button.hover.background}',
          activeBorderColor: '{button.active.background}',
          color: '{primary.contrast.color}',
          hoverColor: '{primary.contrast.color}',
          activeColor: '{primary.contrast.color}',
          focusRing: {
            color: '{sd.secondary.color}',
            shadow: 'none'
          }
        },
        secondary: {
          background: '{sd.backgrounds.secondary.color}',
          hoverBackground: '{sd.secondary.hovercolor.darker}',
          activeBackground: '{primary.700}',
          borderColor: '{sd.backgrounds.secondary.color}',
          hoverBorderColor: '{sd.secondary.hovercolor.darker}',
          activeBorderColor: '{primary.700}',
          color: '{primary.contrast.color}',
          hoverColor: '{primary.contrast.color}',
          activeColor: '{primary.contrast.color}',
          focusRing: {
            color: '{sd.secondary.color}',
            shadow: 'none'
          }
        },
        text: {
          plain: {
            hoverBackground: '{sd.backgrounds.hover}'
          },
          primary: {
            hoverBackground: '{sd.backgrounds.hover}'
          },
          secondary: {
            hoverBackground: '{sd.secondary.hovercolor.lighter}',
            color: '{sd.secondary.color}'
          },
          contrast: {
            hoverBackground: '{sd.secondary.hovercolor.lighter}'
          },
          danger: {
            color: '{sd.utility.danger.normal}'
          },
          success: {
            color: '{sd.utility.success.normal}'
          }
        },
        outlined: {
          primary: {
            borderColor: '{sd.primary.normal}'
          },
          secondary: {
            borderColor: '{sd.secondary.color}',
            color: '{sd.secondary.color}',
            hoverBackground: '{sd.secondary.hovercolor.lighter}'
          },
          danger: {
            borderColor: '{sd.utility.danger.normal}',
            color: '{sd.utility.danger.normal}'
          },
          success: {
            borderColor: '{sd.utility.success.normal}',
            color: '{sd.utility.success.normal}'
          }
        },
        danger: {
          background: '{sd.utility.danger.normal}',
          hoverBackground: '{sd.utility.danger.dark}'
        }
      }
    }
  }
};
